import '../index.css';
import CategoryCard from './CategoryCard';
import './Home.css';
import SearchBarHome from './SearchBarHome';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';

export const Home = () => {
    const [categories, setCategories] = useState([]);
    const auth = useSelector(state => state.auth)

    useEffect(() => {
        const fetchData = async () => {
            const response = await axios.get('https://liwat-id-backend.herokuapp.com/api/categories/');
            setCategories(response.data);
        };

        fetchData();
    }, [])

    return (
        <div className="home">
            <div className="landing">
                {console.log(auth)}
                <div className="title">
                    {/* <div className="d-flex justify-content-left"> */}
                    <h5 className="halo-greet" id="uname">
                    {auth.user == null ? '': auth.user.username.indexOf('@') === -1?
                        "Halo " + auth.user.username + "," : "Halo " + auth.user.username.split('@')[0] + ","
                    }</h5>
                    <h2 className="h2" id="greet">Mulai Petualanganmu!</h2>

                </div>
                <div>
                    <SearchBarHome />
                </div>
            </div>
            <div className="d-flex justify-content-center">
                <div className="category-section mt-5">
                    <h3 className="h3" id="kategori-title">Kategori</h3>
                    <div className="cards-category d-flex justify-content-start mt-4" data-testid="cards-cat">
                        {
                            categories.map(category => {
                                var catName = (category['sub_category'] !== "") ? category['sub_category'] : category['category'];
                                return <CategoryCard image={category.image} title={catName} id={category.id} key={category.id} />
                            })
                        }
                    </div>
                </div>

            </div>


        </div>
    );

}

export default Home;